export default "__VITE_ASSET__C3VDGhAt__"